import { render, staticRenderFns } from "./counter.vue?vue&type=template&id=15e6a2e4&scoped=true&"
import script from "./counter.vue?vue&type=script&lang=js&"
export * from "./counter.vue?vue&type=script&lang=js&"
import style0 from "./counter.vue?vue&type=style&index=0&id=15e6a2e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e6a2e4",
  null
  
)

export default component.exports